import { PaymentScheduleFrequency } from "@wojo/services/generated/graphql";
import { useEffect, useMemo } from "react";
import {
    QuoteCheckoutType,
    usePaymentScheduleMutation,
    WcAutopayCheckoutOptionFragment,
} from "../../../../generated/graphql";
import { useTourPageContext } from "../../../_client/context";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";

export const usePaymentScheduleSuspenseMutation = () => {
    const { draftQuote } = useTripBuilderQuote();
    const { defaultPaymentFrequency } = useTourPageContext();
    const autoPayCheckoutOption = useMemo(() => {
        return draftQuote?.order.checkoutOptions.find(
            (option): option is WcAutopayCheckoutOptionFragment =>
                option.type === QuoteCheckoutType.AutoPay,
        );
    }, [draftQuote]);

    const [paymentSchedule, { loading, data }] = usePaymentScheduleMutation();

    useEffect(() => {
        if (!autoPayCheckoutOption || !draftQuote?._id) {
            return;
        }
        (async () => {
            await paymentSchedule({
                variables: {
                    draftOrderId: draftQuote._id,
                    input: {
                        frequency:
                            defaultPaymentFrequency ||
                            PaymentScheduleFrequency.Monthly,
                    },
                },
            });
        })();
    }, [
        paymentSchedule,
        draftQuote?._id,
        draftQuote?.order.grandTotal.value,
        autoPayCheckoutOption,
        defaultPaymentFrequency,
    ]);
    if (
        loading ||
        data?.calculatePaymentSchedule.__typename !== "PaymentSchedule"
    ) {
        return null;
    }

    return {
        recurringPayment:
            data.calculatePaymentSchedule.installments[0].amount.value,
        numberOfPayments: data.calculatePaymentSchedule.installments.length,
        autoPayCheckoutOption,
    };
};
